var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "selectLayoutModal",
      staticClass: "select-images-modal",
      attrs: {
        id: "select-image-to-analyse-modal",
        title: "Select images to analyze",
        size: "lg",
        "ok-disabled": !_vm.selectedItems.length,
      },
      on: { shown: _vm.getTemplates, hidden: _vm.onModalHidden },
      scopedSlots: _vm._u([
        {
          key: "modal-title",
          fn: function () {
            return [
              _c("span", { staticClass: "select-images-modal__title" }, [
                _vm._v("Select images to analyze"),
              ]),
            ]
          },
          proxy: true,
        },
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center w-100",
                },
                [
                  _c("span", { staticClass: "select-images-modal__selected" }, [
                    _vm._v(_vm._s(_vm.selected) + " Selected"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "buttons" },
                    [
                      _vm.isOptixMode
                        ? _c(
                            "b-button",
                            {
                              staticClass: "mr-4",
                              attrs: { variant: "outline-secondary" },
                              on: { click: _vm.getTemplates },
                            },
                            [_vm._v("\n          Reload\n        ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "light" },
                          on: {
                            click: function ($event) {
                              return _vm.$bvModal.hide(
                                "select-image-to-analyse-modal"
                              )
                            },
                          },
                        },
                        [_vm._v("\n          Cancel\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "select-images-modal__submit-btn",
                          attrs: {
                            variant: "primary",
                            disabled: !_vm.selectedItems.length,
                          },
                          on: { click: _vm.handleOkClick },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                !_vm.isOptixMode
                                  ? "Continue on Optix Lab"
                                  : "Select"
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _vm.isOptixMode && _vm.previews.length > 0
        ? _c("small", [
            _vm._v("\n    To update thumbnails, open the\n    "),
            _c(
              "a",
              {
                staticClass: "btn-save-changes",
                attrs: {
                  href: `/banner/${_vm.customerId}/group/${_vm.layoutId}/show`,
                  target: "_blank",
                },
              },
              [_vm._v("\n      layout\n    ")]
            ),
            _vm._v("\n    and navigate through each page. (new tab)\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "select-images-modal__actions" },
        [
          _c(
            "b-form-checkbox",
            {
              attrs: { checked: _vm.isAllSelected },
              on: { change: _vm.toggleSelectAll },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.isAllSelected ? "Unselect all" : "Select all") +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isLoading && _vm.previews.length > 0
        ? _c(
            "div",
            { staticClass: "mt-2 image-grid" },
            _vm._l(_vm.previews, function (preview, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "image-card-template",
                  class: { selected: _vm.selectedItems.includes(preview.id) },
                  on: {
                    click: function ($event) {
                      return _vm.toggleSelect(preview)
                    },
                  },
                },
                [
                  preview.thumbnail
                    ? _c("img", {
                        style: {
                          objectFit: _vm.isOptixMode ? "contain" : "cover",
                        },
                        attrs: {
                          src: `/share?file=${preview.thumbnail}`,
                          alt: `generated_image_${index + 1}`,
                        },
                        on: { load: _vm.onImageLoad },
                      })
                    : _vm.isOptixMode && !preview.thumbnail
                    ? _c(
                        "a",
                        {
                          staticClass: "btn-save-changes",
                          attrs: {
                            href: `/banner/${_vm.customerId}/group/${_vm.layoutId}/show`,
                            target: "_blank",
                          },
                        },
                        [_vm._v("\n        Update thumbnail\n      ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedItems.includes(preview.id)
                    ? _c("div", { staticClass: "image-card-template__check" }, [
                        _c("i", { staticClass: "bi-check" }),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            0
          )
        : _vm.isLoading
        ? _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-center align-items-center flex-column",
            },
            [
              _c("b-spinner", {
                staticClass: "mr-1 thumbnail-loading",
                attrs: { variant: "light" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Loading previews...")]),
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass: "d-flex justify-content-center align-items-center",
              staticStyle: { height: "200px" },
            },
            [_c("span", [_vm._v("No templates available")])]
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }